import Header from './Header';
import Footer from './Footer';

const Layout = ({ children = null }) => (
  <div className="dark:bg-gray-900 dark:text-white">
    <Header />
    <main className="min-h-screen pt-20 pb-48 px-6 md:px-10 overflow-hidden">
      {children}
    </main>
    <Footer />
  </div>
);

export default Layout;
